<div id="barChart" style="position: relative; height:60vh; width:120vw"></div>